export function normalizeList(values?: string | string[] | null): string[] {
  if (!values) return [];
  const array = Array.isArray(values) ? values : String(values).split(/[,;\n]/);
  const merged: string[] = [];
  array.forEach((entry) => {
    const normalized = entry.trim();
    if (normalized && normalized.toLowerCase() !== "null" && !merged.some((item) => item.toLowerCase() === normalized.toLowerCase())) {
      merged.push(normalized);
    }
  });
  return merged;
}

export function formatDate(value?: string | null, fallback = "—") {
  if (!value) return fallback;
  try {
    return new Date(value).toLocaleDateString();
  } catch {
    return fallback;
  }
}

export function formatDateTime(value?: string | null) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString();
  } catch {
    return "—";
  }
}
